'use client'
import { Title } from '@/components/common'
import { getVND } from '@/utils/helpers'
import { useCartStore } from '@/store'
import { useTranslations } from 'next-intl'
import { LoddingIcon } from '@/components/icon-svg'
import { PaymentMethod } from './payment-method'
import { Control } from 'react-hook-form'
import Image from 'next/image'
import { Fragment } from 'react'
import Button from '@mui/material/Button'
import { Skeleton } from '@mui/material'
interface InforOnderProps {
  isPending?: boolean
  paymentMethod: string
  control: Control<IFormCheckout, any> | any
  setPaymentMethod: (method: string) => void
}

export const InforOrder = ({ isPending, paymentMethod, control, setPaymentMethod }: InforOnderProps) => {
  const t = useTranslations()
  const { cartItems, cartData, isLoading } = useCartStore()
  const shippingFee = cartData?.shipping_addresses?.[0]?.selected_shipping_method

  return (
    <aside className="cart-checkout">
      <div className="p-4 border border-gray-300 rounded-md mb-8">
        <Title variants="h3" text={t('Order summary')} />

        <div className="border-b pb-4 border-solid border-[#eaeaea]">
          <div className="flex items-center justify-between font-semibold mb-2">
            <p>{t('Products')}</p>
            <p>{t('Total')}</p>
          </div>
          {isLoading ? (
            <div className="flex flex-col gap-3">
              <Skeleton animation="wave" />
              <Skeleton animation="wave" />
              <Skeleton animation="wave" />
            </div>
          ) : (
            <>
              {cartItems.map((item, index) => {
                return (
                  <div key={index} className="flex items-center justify-between mb-2">
                    <div className="font-semibold flex items-center gap-3">
                      <Image width={50} height={50} src={item?.configured_variant?.image?.url || ""} alt={item?.product?.name || 'Ảnh sản phẩm trong đơn hàng'} />
                      <div className="flex items-center">
                        <div>
                          <p className="line-clamp-1 text-[1rem]">{item?.product?.name}</p>
                          <p className="sub">
                            {item?.product?.sku}
                            {item?.configurable_options?.map((el) => {
                              return <Fragment key={el?.value_label}>-{el?.value_label}</Fragment>
                            })}
                          </p>
                          <p className="sub">Quantity: x{item?.quantity}</p>
                        </div>
                      </div>
                    </div>
                    <p>{getVND(item?.prices?.row_total?.value)}</p>
                  </div>
                )
              })}
            </>
          )}

          {cartData?.prices?.discounts?.length > 0 &&
            cartData?.prices?.discounts?.map((item, index) => {
              return (
                <div className="flex items-center justify-between mb-2" key={index}>
                  <p>{item?.label}</p>
                  <p>-{getVND(item?.amount?.value)}</p>
                </div>
              )
            })}
          {shippingFee?.amount?.value && (
            <div className="flex items-center justify-between mb-2">
              <p>{t('Shipping_fee')}</p>
              <p>{getVND(shippingFee?.amount?.value)}</p>
            </div>
          )}
        </div>
        <div className="flex items-center justify-between font-semibold my-3">
          <p>{t('Total')}</p>
          <p>{getVND(cartData?.prices?.grand_total?.value)}</p>
        </div>
        <PaymentMethod control={control} paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod} />
        <Button
          // type="primary"
          className={`!flex w-full items-center justify-center gap-2`}
          size="large"
          type="submit"
          variant="contained"
        >
          {t('Checkout')}
          {/* {step == 1 ? 'Tiếp theo' : 'Thanh toán'} */}
          {isPending && <LoddingIcon />}
        </Button>
      </div>
    </aside>
  )
}
